import Cookies from 'js-cookie'

import anonymousUserApi from 'api/ApiActions/Common/AnonymousUser'

export const fetchAnonymousUserToken = async () => {
  return anonymousUserApi.getAnonymousUserToken({
    credentials: 'same-origin',
  })
}

const StoreAnonymousToken = (rawData: any) => {
  const { data: { data: { token = '' } = {} } = {}, status } = rawData || {}

  if (status >= 200 && status <= 299) {
    localStorage.setItem('UNEXPECTED-THUNDER', token)
    Cookies.set('unexpected_thunder', token)
  }

  return {
    data: token,
  }
}

const AnonymousUserResponses = {
  StoreAnonymousToken,
}

export default AnonymousUserResponses
